import MarketTable from './MarketTable';
import { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import MarketRegistration from './MarketRegistration';
import MarketTemplateSlideModal from './MarketTemplateSlideModal';

export default function Market() {
	const [IsRegistSlideModal, setIsRegistSlideModal] = useState(false);
	const [IsTemplateSlideModal, setIsTemplateSlideModal] = useState(false);
	const [SelectedData, setSelectedData] = useState({});

	const handleButton = (e) => {
		e.preventDefault();
		if (IsRegistSlideModal) {
			/* eslint-disable no-restricted-globals */
			const isOk = confirm('등록을 취소하시겠습니까?');
			/* eslint-enable no-restricted-globals */
			if (isOk) {
				setIsRegistSlideModal(!IsRegistSlideModal);
				setSelectedData({});
			}
		} else {
			setIsRegistSlideModal(!IsRegistSlideModal);
		}
	};
	const handleTemplateButton = (e) => {
		e.preventDefault();
		if (IsTemplateSlideModal) {
			/* eslint-disable no-restricted-globals */
			const isOk = confirm('템플릿 수정을 취소하시겠습니까?');
			/* eslint-enable no-restricted-globals */
			if (isOk) {
				setIsTemplateSlideModal(!IsTemplateSlideModal);
			}
		} else {
			setIsTemplateSlideModal(!IsTemplateSlideModal);
		}
	};
	return (
		<>
			<div className='market-layout'>
				<div className='market-top'>
					<div className='button'>
						<div className='registration'>
							<h2>상품등록</h2>
							<span className='checkbox checked'>
								{!IsRegistSlideModal
									? `'등록하기'를 누르면 상품등록이 진행됩니다.`
									: '상품등록이 진행중입니다.'}
							</span>
						</div>
						<button onClick={(e) => handleButton(e)}>
							{!IsRegistSlideModal ? '등록하기' : '등록 취소'}
						</button>
					</div>
					<div className='button'>
						<div className='registration template'>
							<h2>템플릿 관리</h2>
							<span className='checkbox checked'>
								{!IsTemplateSlideModal
									? `'관리하기'를 누르면 템플릿 수정이 진행됩니다.`
									: '템플릿 수정이 진행중입니다.'}
							</span>
						</div>
						<button onClick={(e) => handleTemplateButton(e)}>
							{!IsTemplateSlideModal ? '관리하기' : '수정 취소'}
						</button>
					</div>
					{/* {IsRegistSlideModal && (
						<div className='selectedData'>
							<h3>선택한 내용</h3>
							<p>마켓 : {SelectedData.market}</p>
							<p>마켓ID : {SelectedData.marketID}</p>
							<p>작업줄명: {SelectedData.taskName}</p>
							<p>템플릿 : {SelectedData.template}</p>
							<p>북마크 상품 : {SelectedData.scrap}</p>
						</div>
					)} */}
				</div>
				<MarketTable />
				<AnimatePresence>
					{IsRegistSlideModal && (
						<MarketRegistration
							getSelectedData={setSelectedData}
							getIsRegistSlideModal={setIsRegistSlideModal(false)}
						/>
					)}
					{IsTemplateSlideModal && (
						<MarketTemplateSlideModal
							getIsTemplateSlideModal={setIsTemplateSlideModal(false)}
						/>
					)}
				</AnimatePresence>
			</div>
		</>
	);
}
